import { TransferValidateType } from '@/helpers/transfer/transfer.interfaces';
import { Money } from '@libs/money/money.interfaces';

export interface TransferEndpoint {
    Search(request: SearchTransferRequest): Promise<SearchTransferResponse>;
}

export type TransferFlightTimeKey = 'flightArrivalTime' | 'flightDepartureTime';
export type TransferConnectionObject = 'from' | 'to';

export interface SearchTransferRequest {
    startTime: string | null;
    flightArrivalTime: string | null;
    flightDepartureTime: string | null;
    passengers: SearchPassengers;
    from: SearchLocation;
    to: SearchLocation;
    market: string;
}

export interface SearchPassengers {
    adults: number;
    children: number;
    infants: number;
}

export interface SearchLocation {
    type: SearchLocationType;
    iata?: string;
    address?: string;
    coordinates?: SearchLocationCoordinates;
    hotelName?: string;
}

export interface SearchLocationCoordinates {
    latitude: number;
    longitude: number;
}

export enum SearchLocationType {
    Coordinates = 'coordinates',
    Address = 'address',
    Iata = 'iata',
}

enum TransferType {
    PRIVATE = 'PRIVATE',
    SHARED = 'SHARED',
}

export interface SearchTransferResponse {
    StartTime: Date;
    Options: TransferOption[];
}

export interface TransferOption {
    Id: string;
    Duration: number | null;
    OptionSeats: TransferOptionSeats;
    Price: TransferPrice;
    FreeCancelUntil: Date | null;
    Extras: TransferOptionExtra[];
    MaxLargeLuggage: number | null;
    Distance: number | null;
    TollsIncluded: boolean;
    GratuityIncluded: boolean;
    DriverWaitingTime: number | null;
    TransferVehicle: TransferOptionVehicle;
    TransferPartner: TransferOptionPartner;
    CancellationPolicyText: string | null;
    TransferType: TransferType;
    DisclaimerTitle: string | null;
    DisclaimerDescription: string | null;
    SupplierPrice?: Money | null;
    PickUpTime?: string | null;
    IsSharedTransfer: boolean;
}

export interface TransferOptionItem extends TransferOption {
    Validation?: TransferOptionItemValidation;
}

interface TransferOptionItemValidation {
    Type: TransferValidateType;
    Message: string;
}

export interface TransferOptionVehicle {
    Image: string;
    Model: string;
    ServiceType: string;
    CategoryType: string;
}
export interface TransferOptionPartner {
    Name: string;
    Logo: string;
}

interface TransferOptionSeats {
    Adults: number | null;
    Children: number | null;
    Infants: number | null;
    Total: number | null;
}

interface TransferPrice {
    Amount: number;
    Currency: string;
}

interface TransferOptionExtra {
    Id: string;
    Price: TransferPrice;
    Type: string;
    MaxCount: number;
    Count: number;
    Description: string;
}
